import { render, staticRenderFns } from "./WebhookVietguysList.vue?vue&type=template&id=0040d54d&scoped=true"
import script from "./WebhookVietguysList.vue?vue&type=script&lang=js"
export * from "./WebhookVietguysList.vue?vue&type=script&lang=js"
import style0 from "./WebhookVietguysList.vue?vue&type=style&index=0&id=0040d54d&prod&scoped=true&lang=css"
import style1 from "./WebhookVietguysList.vue?vue&type=style&index=1&id=0040d54d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0040d54d",
  null
  
)

export default component.exports